<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{ 'Create cash report item'|translate }}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <form [formGroup]="form" fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto">

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>{{'Proof'|translate}}</mat-label>
                    <input matInput formControlName="proof" required>
                    <mat-error>{{'Proof is required!'|translate}}</mat-error>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="income">
                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>{{'Income'|translate}}</mat-label>
                    <input matInput formControlName="income" required>
                    <mat-error>{{'Income is required!'|translate}}</mat-error>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="!income">
                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>{{'Outcome'|translate}}</mat-label>
                    <input matInput formControlName="outcome" required>
                    <mat-error>{{'Outcome is required!'|translate}}</mat-error>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Description'|translate}}</mat-label>
                    <textarea matInput formControlName="description"></textarea>
                </mat-form-field>
            </div>


        </form>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="Cancel">
            {{'Cancel'|translate}}
        </button>
        <button
                mat-button
                class="save-button"
                (click)="matDialogRef.close(form)"
                [disabled]="form.invalid"
                aria-label="Save">
            {{'Save'|translate}}
        </button>

    </div>
</div>
